import { Asset, Device, Event, Site } from '@iot-platform/models/i4b';
import { Address } from '@iot-platform/models/common';

export function getSiteFromEventContext(context: Event['context']): Partial<Site> {
  return {
    id: context.site.id,
    name: context.site.name,
    entity: { ...context.entity },
    type: context.site.type,
    address: { city: context.site.city } as Partial<Address>,
    customerNumber: context.site.customerNumber
  } as Partial<Site>;
}

export function getDeviceFromEventContext(context: Event['context']): Partial<Device> {
  return {
    id: context.device.id,
    name: context.device.name,
    communication: { support: context.device.support },
    identifier: context.device.identifier,
    type: { model: context.device.model, family: context.device.family, firmware: context.device.firmware },
    incomingConnector: { id: context.device.incomingConnectorId },
    outgoingConnector: { id: context.device.outgoingConnectorId },
    entity: { ...context.entity },
    site: getSiteFromEventContext(context),
    status: { name: context.device.status } as Partial<Device['status']>
  } as Partial<Device>;
}

export function getAssetFromEventContext(context: Event['context']): Partial<Asset> {
  return {
    id: context.asset.id,
    name: context.asset.name,
    entity: { ...context.entity },
    equipmentId: context.asset.equipmentId,
    site: getSiteFromEventContext(context),
    status: { name: context.asset.status },
    dispatch: { shipTo: context.asset.shipTo }
  } as Partial<Asset>;
}
